<div class="form-group">
    <label [for]="id" >{{title}} {{control | controlRequiredText}}</label>

    <i [class.d-none]="!tooltip" class="mgn-left-6 pj-ico pj-ico-ayuda-info text-primary"
    data-toggle="popover" data-placement="top"
    data-trigger="hover"
    data-html="true"
    [attr.data-content]="tooltip"
    tabindex="0"></i>

    <input-select 
    [id]="id"
    [title]="title"
    [control]="control"
    [enabledDefaultOption]="enabledDefaultOption"
    [dataSelect]="dataSelect"
    [placeholder]="placeholder">
    </input-select>

    <div-validation-message [control]="control" [messageRequired]="messageRequired"></div-validation-message>
</div>